<script setup lang="ts">
import {computed, toRaw} from 'vue'
import { itemScopeAttributes, useModelStrings, type ItemTemplateProps } from '@jantm/model-core'
import type {Relation} from "@/types/Wiser/relation.ts";
import {useRouter} from "vue-router";

/**
 * Custom item rendering for Relation.
 *
 * Narrowing `entity` to `Relation` is the whole point of a per-model template: the
 * props contract stays the one model-core passes, but inside this file the
 * entity is fully typed.
 */
const props = withDefaults(defineProps<ItemTemplateProps<Relation>>(), { headingLevel: 3 })

const { t, locale } = useModelStrings(() => props.definition)

const scope = computed(() => itemScopeAttributes(props.definition))
const heading = computed(() => `h${props.headingLevel}` as const)
const router = useRouter()
const entityId = computed<number>(() => props.entity?.id ?? 0)
const entityName = computed(() => props.entity?.relatietype === 'particulier' ?
  `${props.entity.aanhef ?? ''} ${props.entity.voorletters ?? ''} (${props.entity.voornaam ?? ''}) ${props.entity.tussenvoegsel ?? ''} ${props.entity.achternaam ?? ''}` :
  props.entity.bedrijfsnaam ?? '')
const gotoDetail = function() {
  router.push({name: 'wiser-relation', params: {id: entityId.value}})
}
</script>

<template>
  <article
    class="wiser-item relation-item"
    v-bind="scope"
    @click="gotoDetail"
  >
    <component
      :is="heading"
      class="wiser-item__title relation-item__title"
    >
      <span>{{ entity.id }}</span>
      <span class="wiser-item__badge relation-item__badge">{{ entity.relatietype }}</span>
    </component>
    <span>{{ entityName }}</span>
  </article>
</template>
